/**
 * Generic step validator.
 * Runs the `validate(value, form)` function of each enabled field in the list.
 * Validation is fully decoupled from the component — it lives on the field definition.
 */
export const validateStep = (fields, form) => {
  const formErrors = {};

  fields.forEach((field) => {
    if (!field.enabled || !field.validate) return;

    const error = field.validate(form[field.name], form);
    if (error) formErrors[field.name] = error;
  });

  return formErrors;
};
